import api from "../index"

const icdsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getIcdsList: build.query({
      query: (params) => ({
        url: `/icds`,
        method: "GET",
        params,
      }),
    }),
    createIcd: build.mutation({
      query: (body) => ({
        url: `/icds`,
        method: "POST",
        body,
      }),
    }),
    getIcdDetails: build.query({
      query: ({ id }) => ({
        url: `/icds/${id}`,
        method: "GET",
      }),
    }),
    icdCounterOffer: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/icds/counter-offer/${id}`,
        method: "POST",
        body: params,
      }),
    }),

    icdApproveOffer: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/icds/approve/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    icdRejectOffer: build.mutation({
      query: ({ id }) => ({
        url: `/icds/reject/${id}`,
        method: "GET",
      }),
    }),
    deleteIcd: build.mutation({
      query: ({ id }) => ({
        url: `/icds/${id}`,
        method: "DELETE",
      }),
    }),
    getIcdMyInterest: build.query({
      query: ({ id }) => ({
        url: `/investor/icds/get-interest/${id}`,
        method: "GET",
      }),
    }),
    getIcdSigningRequests: build.query({
      query: (params) => ({
        url: `/icds/signingRequests`,
        method: "GET",
        params,
      }),
    }),
    getOfflinePayments: build.query({
      query: () => ({
        url: `/icds/payments`,
        method: "GET",
      }),
    }),
    approveIcdPayment: build.mutation({
      query: (body) => ({
        url: `/icds/payment/approve`,
        method: "POST",
        body,
      }),
    }),
    rejectIcdPayment: build.mutation({
      query: (body) => ({
        url: `/icds/payment/reject`,
        method: "POST",
        body,
      }),
    }),
    pendingIcdPayments: build.query({
      query: (params) => ({
        url: `/icds/pending-payments`,
        method: "GET",
        params,
      }),
    }),
    payPendingIcdPayments: build.mutation({
      query: (body) => ({
        url: `/icds/pending-payments/pay`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetIcdsListQuery,
  useCreateIcdMutation,
  useDeleteIcdMutation,
  useLazyGetIcdDetailsQuery,
  useIcdCounterOfferMutation,
  useIcdApproveOfferMutation,
  useIcdRejectOfferMutation,
  useLazyGetIcdMyInterestQuery,
  useLazyGetIcdSigningRequestsQuery,
  useLazyGetOfflinePaymentsQuery,
  useApproveIcdPaymentMutation,
  useRejectIcdPaymentMutation,
  useLazyPendingIcdPaymentsQuery,
  usePayPendingIcdPaymentsMutation,
} = icdsApi
